module.exports = __webpack_public_path__ + "img/hand-thumbs-down.740d3544.svg";